import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./_api/auth.js";
// import { AuthContextProvider } from "./context/AuthContext";
// import { Provider } from 'react-redux';
// import store from './redux/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      fetchonconnect: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    {/* <AuthContextProvider> */}
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: "PoppinsRegular",
            fontSize: "12px",
          },
        }}
      />

      <App />
    </AuthProvider>
    {/* </AuthContextProvider> */}
  </QueryClientProvider>
);
